import * as C from "../constants/actionType";

const initialState = {
    isFetching: false,
    isFetched: false,
    faq: []
};

export default function faq(state = initialState, action) {
    switch (action.type) {
        case C.FETCH_FAQ:
            return Object.assign({}, state, {
                isFetching: true
            });
        case C.FETCH_FAQ_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                isFetched: true,
                faq: action.payload
            });
        case C.FETCH_FAQ_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                isFetched: false,
                faq: []
            });

        default:
            return state;
    }
}
